export default function Pagination(props) {
  const {
    totalPages,
    currentPage,
    setCurrentPage
  } = props
  const handleNext = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePrevious = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  // Handle page number click
  const handlePageClick = (page) => {
    setCurrentPage(page);
  };

  const generatePageNumbers_ = () => {
    
    
    if (totalPages <= 5) {
      return Array.from({ length: totalPages }, (_, i) => i + 1);
    }

    const pages = [];
    pages.push(1);

    if (currentPage <= 4) {
      for (let i = 2; i <= 5; i++) pages.push(i);
      pages.push("...");
    } else if (currentPage >= totalPages - 3) {
      pages.push("...");
      for (let i = totalPages - 4; i < totalPages; i++) pages.push(i);
    } else {
      pages.push("...");
      for (let i = currentPage - 2; i <= currentPage + 2; i++) pages.push(i);
      pages.push("...");
    }

    pages.push(totalPages);
    return pages;
  };
  // const generatePageNumbers_ = () => {
  //   if (totalPages <= 5) {
  //     // Show all pages if 10 or less
  //     return Array.from({ length: totalPages }, (_, i) => i + 1);
  //   }

  //   const pages = [];

  //   // Always show first page
  //   pages.push(1);

  //   // Calculate what to show based on current page
  //   if (currentPage <= 4) {
  //     // Show pages 2-5, then ellipsis, then last page
  //     for (let i = 2; i <= 5; i++) pages.push(i);
  //     pages.push('...');
  //   }
  //   else if (currentPage >= totalPages - 3) {
  //     // Show ellipsis, then pages near the end
  //     pages.push('...');
  //     for (let i = totalPages - 4; i < totalPages; i++) pages.push(i);
  //   }
  //   else {
  //     // Show ellipsis, current-2 to current+2, ellipsis
  //     pages.push('...');
  //     for (let i = currentPage - 2; i <= currentPage + 2; i++) pages.push(i);
  //     pages.push('...');
  //   }

  //   // Always show last page
  //   pages.push(totalPages);

  //   return pages;
  // };








  return (

    <div className="pagination">
      <div className="flex items-center justify-center space-x-1 mt-6 p-2 max-sm:space-x-0 max-sm:gap-1 max-sm:flex-wrap">
        {/* Previous Button */}
        <button
          onClick={handlePrevious}
          disabled={currentPage === 1}
          className={`px-3 py-2 rounded-md border ${currentPage === 1
            ? "bg-gray-200 text-gray-400 cursor-not-allowed"
            : "hover:bg-gray-100"
            } max-sm:px-2 max-sm:py-1 max-sm:text-xs`}
        >
          Previous
        </button>

        {/* Page Numbers */}
        {generatePageNumbers_().map((page, index) =>
          page === "..." ? (
            <span
              key={`ellipsis-${index}`}
              className="px-2 py-1 max-sm:px-1 max-sm:text-xs"
            >
              ...
            </span>
          ) : (
            <button
              key={page}
              onClick={() => handlePageClick(page)}
              className={`border px-3 py-2 rounded-md ${page === currentPage
                ? "bg-[#0c2f55] text-white"
                : "hover:bg-gray-100"
                } max-sm:px-2 max-sm:py-1 max-sm:text-xs`}
            >
              {page}
            </button>
          )
        )}

        {/* Next Button */}
        <button
          onClick={handleNext}
          disabled={currentPage === totalPages}
          className={`px-3 py-2 rounded-md border ${currentPage === totalPages
            ? "bg-gray-200 text-gray-400 cursor-not-allowed"
            : "hover:bg-gray-100"
            } max-sm:px-2 max-sm:py-1 max-sm:text-xs`}
        >
          Next
        </button>
      </div>
    </div>
  );
}